enum TimeState {
  PAST_OPEN = 'PAST_OPEN',
  AFTER_BOOKED_DAY = 'AFTER_BOOKED_DAY',
  BOOKED_PRE_EVENT = 'BOOKED_PRE_EVENT',
  BOOKED_PAST_EVENT = 'BOOKED_PAST_EVENT',
}

export default TimeState;
